// tslint:disable max-line-length
import { CreateDataByIndexedDB, GetAllDataByIndexedDB } from '../../indexed/index';
import { userHotelDetails } from '../../helpers/handleBrandAndHotelData';
import axiosInstance from '../../helpers/interceptor';

export const missedstandardApi = async (selectedAssessment, currentPage, standard, performanceClassification) => {
    const { selectedHotel } = userHotelDetails();
    if (performanceClassification && performanceClassification === 'all') {
    performanceClassification = undefined;
}
    if (standard === 'LQA') {
    standard = 1;
}
    let dataD: any = [];
    const OfflineData = await GetAllDataByIndexedDB(`${Env.API_URL}/customer/missed-standards/hotel/${selectedHotel}/by-standard?&${performanceClassification ? '&performanceClassifier=' + performanceClassification : ''}&scoreType=${standard}&endDate=${selectedAssessment}&page=${currentPage}&pageSize=200&assessmentId=${selectedAssessment}&isClientApp=true`, selectedHotel);
    if (OfflineData) {
        dataD = OfflineData;
    } else {
        const { data } = await axiosInstance.get(`${Env.API_URL}/customer/missed-standards/hotel/${selectedHotel}/by-standard?&${performanceClassification ? '&performanceClassifier=' + performanceClassification : ''}&scoreType=${standard}&endDate=${selectedAssessment}&page=${currentPage}&pageSize=200&assessmentId=${selectedAssessment}&isClientApp=true`);
        dataD = data;
        CreateDataByIndexedDB(`${Env.API_URL}/customer/missed-standards/hotel/${selectedHotel}/by-standard?&${performanceClassification ? '&performanceClassifier=' + performanceClassification : ''}&scoreType=${standard}&endDate=${selectedAssessment}&page=${currentPage}&pageSize=200&assessmentId=${selectedAssessment}&isClientApp=true`, data, selectedHotel);
    }
    return dataD;
};
